/**
 * ページタイトル
 */
const PAGE_TITLE = {
  CUSTOMER_CARD: '会員証',
  COUPON: 'クーポンBOX',
  EXCHANGE_COUPON: 'ポイントをクーポンに交換', // ポイント機能有効時
  GET_COUPON: 'クーポン一覧', // ポイント機能無効時
  POINT_HISTORY: 'ポイント履歴',
  STAMP_CARD: 'スタンプカード',
  STAMP_CARD_HISTORY: 'スタンプカード履歴',
  SHARE_CAMPAIGN: 'シェアキャンペーン',
};

/**
 * タブバー（フッターメニュー）
 */
const MENU = {
  CUSTOMER_CARD: '会員証',
  COUPON: 'クーポンBOX',
  EXCHANGE_COUPON: 'ポイント交換', // ポイント機能有効時
  GET_COUPON: 'クーポン取得', // ポイント機能無効時
  POINT_HISTORY: 'ポイント履歴',
};

/**
 * キーワード
 */
const KEYWORD = {
  CUSTOMER_CARD: '会員証',
  COUPON: 'クーポン',
  POINT: 'ポイント',
  POINT_UNIT: 'pt',
};

/**
 * 会員アプリ ラベル設定デフォルト値
 */
const DEFAULT_APP_LABEL = {
  title: {
    customerCard: PAGE_TITLE.CUSTOMER_CARD,
    coupon: PAGE_TITLE.COUPON,
    exchangeCoupon: PAGE_TITLE.EXCHANGE_COUPON,
    getCoupon: PAGE_TITLE.GET_COUPON,
    pointHistory: PAGE_TITLE.POINT_HISTORY,
    stampCard: PAGE_TITLE.STAMP_CARD,
    stampCardHistory: PAGE_TITLE.STAMP_CARD_HISTORY,
    shareCampaign: PAGE_TITLE.SHARE_CAMPAIGN,
  },
  menu: {
    customerCard: MENU.CUSTOMER_CARD,
    coupon: MENU.COUPON,
    exchangeCoupon: MENU.EXCHANGE_COUPON,
    getCoupon: MENU.GET_COUPON,
    pointHistory: MENU.POINT_HISTORY,
  },
  keyword: {
    customerCard: KEYWORD.CUSTOMER_CARD,
    coupon: KEYWORD.COUPON,
    point: KEYWORD.POINT,
    pointUnit: KEYWORD.POINT_UNIT,
  },
};

export { PAGE_TITLE, MENU, KEYWORD, DEFAULT_APP_LABEL };
